<template>
  <div class="Reg" >
    <van-nav-bar title="" fixed bord>
		<template #left>
			<van-icon name="wap-home-o" size="20px" @click="onClickLeft" />
		</template>
    </van-nav-bar>

    <div class="reg-img">
      <img round width="100" height="100" src="../assets/logo.png" />
    </div>
    <div class="regst" v-if="registeType== 3">
      <van-row class="van-row" type="flex" justify="center">
        <van-cell-group>
          <van-field
            v-model.trim="params.nickname"
            label="昵称："
            placeholder="请输入昵称"
            clearable
          ></van-field>
          <van-field
            type="number"
            v-model.trim="params.phone"
            label="手机号："
            placeholder="请输入手机号"
            clearable
          ></van-field>
          <van-field v-model.trim="params.message" label="验证码：" placeholder="短信验证码" clearable>
            <template #button>
              <van-button size="small" v-show="sendCode" type="info" @click="getCode">获取验证码</van-button>
              <van-button size="small" v-show="!sendCode" type="info">{{auth_time}}秒后重新获取</van-button>
            </template>
          </van-field>
          <van-field
            v-model.trim="params.password"
            type="password"
            label="密码："
            placeholder="请输入密码"
            clearable
          />
          <van-field
            v-model.trim="params.password2"
            type="password"
            label="密码："
            placeholder="请输入确认密码"
            clearable
          />
          <van-field
            class="scancode"
            v-model.trim="params.code"
            clearable
            label="邀请码："
            placeholder="请输入邀请码"
            @blur="validateCode"
          >
            <img
              slot="right-icon"
              src="../assets/img/login/saocode.png"
              @click="sacnCode"
              v-if="platforms=='app'"
            />
          </van-field>
        </van-cell-group>
      </van-row>
      <div class="reg-btn-box">
        <van-button block @click="onSubmit1()">注册</van-button>
      </div>
    </div>
    <van-tabs v-model="active" v-if="registeType== 2">
      <van-tab title="手机号注册">
        <van-row class="van-row" type="flex" justify="center">
          <van-cell-group>
          <van-field
            v-model.trim="params.nickname"
            label="昵称："
            placeholder="请输入昵称"
            clearable
          ></van-field>
            <van-field
              type="number"
              v-model.trim="params.phone"
              label="手机号："
              placeholder="请输入手机号"
              clearable
            ></van-field>
            <van-field v-model.trim="params.message" label="验证码：" placeholder="短信验证码" clearable>
              <template #button>
                <van-button size="small" v-show="sendCode" type="info" @click="getCode">获取验证码</van-button>
                <van-button size="small" v-show="!sendCode" type="info">{{auth_time}}秒后重新获取</van-button>
              </template>
            </van-field>
            <van-field
              v-model.trim="params.password"
              type="password"
              label="密码："
              placeholder="请输入数字加字母6~16位密码"
              clearable
            />
            <van-field
              v-model.trim="params.password2"
              type="password"
              label="密码："
              placeholder="请输入确认密码"
              clearable
            />
            <van-field
              class="scancode"
              v-model.trim="params.code"
              clearable
              label="邀请码："
              placeholder="请输入邀请码"
            >
              <img
                slot="right-icon"
                src="../assets/img/login/saocode.png"
                @click="sacnCode"
                v-if="platforms=='app'"
              />
            </van-field>
          </van-cell-group>
        </van-row>
        <div class="reg-btn-box">
          <van-button block @click="onSubmit1()" :disabled="isDisable">注册</van-button>
        </div>
      </van-tab>
      <van-tab title="账号注册">
        <van-row class="van-row" type="flex" justify="center">
          <van-cell-group>
          <van-field
            v-model.trim="params.nickname"
            label="昵称："
            placeholder="请输入昵称"
            clearable
          ></van-field>
            <van-field
              v-model.trim="params.loginID"
              clearable
              label="账号："
              placeholder="请输入账号，字母数字组合6~12位"
            />
            <van-field
              v-model.trim="params.password"
              type="password"
              label="密码："
              placeholder="请输入数字加字母6~16位密码"
              clearable
            />
            <van-field
              v-model.trim="params.password2"
              type="password"
              label="密码："
              placeholder="请输入确认密码"
              clearable
            />
            <van-field
              class="vercode"
              v-model.trim="params.captcha"
              clearable
              label="验证码："
              placeholder="请输入验证码"
            >
              <img
                class="codeImg"
                slot="right-icon"
                :src="imgCode"
                alt="验证码"
                @click="changeImgCode"
              />
            </van-field>
            <van-field
              class="scancode"
              v-model.trim="params.code"
              clearable
              label="邀请码："
              placeholder="请输入邀请码"
            >
              <img
                slot="right-icon"
                src="../assets/img/login/saocode.png"
                @click="sacnCode"
                v-if="platforms=='app'"
              />
            </van-field>
          </van-cell-group>
        </van-row>
        <div class="reg-btn-box">
          <van-button block @click="onSubmit()">注册</van-button>
        </div>
      </van-tab>
    </van-tabs>
    <div class="regst" v-else>
      <van-row class="van-row" type="flex" justify="center">
        <van-cell-group>
          <van-field
            v-model.trim="params.nickname"
            label="昵称："
            placeholder="请输入昵称"
            clearable
          ></van-field>
          <van-field
            v-model.trim="params.loginID"
            clearable
            label="账号："
            placeholder="请输入账号，字母数字组合6~12位"
          />
          <van-field
            v-model.trim="params.password"
            type="password"
            label="密码："
            placeholder="请输入数字加字母6~16位密码"
            clearable
          />
          <van-field
            v-model.trim="params.password2"
            type="password"
            label="密码："
            placeholder="请输入确认密码"
            clearable
          />
          <van-field
            class="vercode"
            v-model.trim="params.captcha"
            clearable
            label="验证码："
            placeholder="请输入验证码"
          >
            <img class="codeImg" slot="right-icon" :src="imgCode" alt="验证码" @click="changeImgCode" />
          </van-field>
          <van-field
            class="scancode"
            v-model.trim="params.code"
            clearable
            label="邀请码："
            placeholder="请输入邀请码"
          >
            <img
              slot="right-icon"
              src="../assets/img/login/saocode.png"
              @click="sacnCode"
              v-if="platforms=='app'"
            />
          </van-field>
        </van-cell-group>
      </van-row>
      <div class="reg-btn-box">
        <van-button block @click="onSubmit()" :disabled="isDisable">注册</van-button>
      </div>
    </div>
    <div class="reg-wechat" @click="wxHandLogin" v-if="wxConfigs.appid">
      <img src="../assets/img/icon/wechat.png" class="icon" />微信授权注册
    </div>
    <div class="return">
      已有账号/
      <span class="login" @click="toLogin">返回登录</span>
    </div>
    <div class="app_download" v-if="platforms!='app'&&showAppDownload">
      <div class="container">
        <img class="logo" src="../assets/logo.png" />
        <div class="note">
          <div class="site_name" v-text="siteTitle"></div>手机APP，更便捷高效体验！
        </div>
        <div class="btn_download" @click="tapDownload()">立即下载</div>
        <div class="close" @click="showAppDownload=!showAppDownload">X</div>
      </div>
    </div>
		<van-popup v-model="showQRCodeUrl" position="bottom" :style="{ 'max-height': '80%' ,'text-align':'center','padding-bottom':(platforms!='app'&&showAppDownload)?'50px':'10px'}">
			<van-cell-group title="微信扫一扫登录" class="pay_type_group">
				<vue-qr :text="QRCodeUrl" :size="220"></vue-qr>
				<br>
				<van-button
				  class="btn"
				  v-clipboard:copy="QRCodeUrl"
				  v-clipboard:success="onCopy"
				  v-clipboard:error="onError"
				>复制链接至微信打开</van-button>
			</van-cell-group>
		</van-popup>
  </div>
</template>
<script>
import md5 from "js-md5";
import vueQr from "vue-qr";
import {chkAndroidOrios,chkWeiXin,compWxAuthUrl} from "@/utils/common.js";
export default {
	name: "Reg",
	components: {
		"vue-qr":vueQr
	},
	data() {
		return {
			siteTitle:top._SHARE_INFO.title,
			wxConfigs:{},
			registeType:1,
			params: {
				nickname:"",
				loginID: "",
				password: "",
				password2: "",
				code: "",
				captcha: "",
				phone: "",
				message: ""
			},
			winH: null,
			imgCode:'',//this.Conf.serverUrl + "Verify/getVerify" + "?num=" + Math.random(), // 获取验证码,
			showAppDownload: true,
			sendCode: true,
			codeTime: 0,
			auth_time: 0,
			active: 2,
			verifyCode: "", //验证码
			errors: {},
			value: [],
			isDisable:false,
			platforms:this.Conf.platform,
			prePath:localStorage.getItem("before_path"),
			showQRCodeUrl:false,
			QRCodeUrl:''
		};
	},
	mounted(){
		if(localStorage.getItem("u_id") && localStorage.getItem(localStorage.getItem("u_id") + "token")){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "已有登录信息，确认退出？",
			})
			.then(() => {
				
			})
			.catch((error) => {
				if(localStorage.getItem("before_path")){
					this.$router.push({ path: localStorage.getItem("before_path") });
					localStorage.removeItem("before_path");
				}else{
					this.$router.push({ path: "/" });
				}
				
			});
		}
	},
	created() {
		if(this.$route.query.code){
			localStorage.setItem("inviter_code", this.$route.query.code);
		}
		this.params.code = localStorage.getItem("inviter_code")||"";
		this.getStateConfigs();
		this.changeImgCode();
	},
	computed: {
		verify() {
		  if (!this.params.loginID) {
			return { flag: false, msg: "请填写账号" };
		  }
		  if (
			!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/.test(
			  this.params.loginID
			)
		  ) {
			return { flag: false, msg: "账号必须是数字加字母6~12位" };
		  }
		  if (
			!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(
			  this.params.password
			)
		  ) {
			return { flag: false, msg: "密码必须是数字加字母6到16位" };
		  }
		  if (this.params.password.length < 6 || this.params.password.length > 16) {
			return { flag: false, msg: "密码长度在6~16个字符之间" };
		  }
		  if (this.params.password != this.params.password2) {
			return { flag: false, msg: "两次输入的密码不一致" };
		  }
		  if (!this.params.captcha) {
			return { flag: false, msg: "请输入验证码" };
		  }
		  // if (!/^1[3456789]\d{9}$/.test(this.params.phone)) {
		  //     return { flag: false, msg: "请输入正确的手机号" };
		  // }
		  // if (!/^1[3456789]\d{9}$/.test(this.params.message)) {
		  //     return { flag: false, msg: "请输入正确的短信验证码" };
		  // }
		  return { flag: true, msg: "ok" };
		},
		verifyMsg() {
		  if (!this.params.phone) {
			return { flag: false, msg: "请填写手机号" };
		  }
		  if (!/^1[3456789]\d{9}$/.test(this.params.phone)) {
			return { flag: false, msg: "请输入正确的手机号" };
		  }
		  if (
			!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(
			  this.params.password
			)
		  ) {
			return { flag: false, msg: "密码必须是数字加字母6到16位" };
		  }
		  if (this.params.password.length < 6 || this.params.password.length > 16) {
			return { flag: false, msg: "密码长度在6-16个字符之间" };
		  }
		  if (this.params.password != this.params.password2) {
			return { flag: false, msg: "两次输入的密码不一致" };
		  }
		  if (!this.params.message) {
			return { flag: false, msg: "请输入验证码" };
		  }
		  return { flag: true, msg: "ok" };
		},
		verifyCphone() {
		  if (!this.params.phone) {
			return { flag: false, msg: "请填写手机号" };
		  }
		  if (!/^1[3456789]\d{9}$/.test(this.params.phone)) {
			return { flag: false, msg: "请输入正确的手机号" };
		  }
		  return { flag: true, msg: "ok" };
		}
	},
	methods: {
		onClickLeft() {
			this.$router.push({ path: this.Conf.homeUrl });
		},
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				this.wxConfigs = this.$store.state.common.wx_mp
				if(confs.registeType){
					this.registeType = confs.registeType.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		onSubmitBase(data){
			this.isDisable = true;
			var url = this.Conf.serverUrl + "Regist/index" + "?num=" + Math.random();
			data.device_type = chkAndroidOrios()?2:1;
			this.$axios
			.post(url, this.$qs.stringify(data))
			.then(response => {
				this.isDisable = false;
				switch (response.data.code) {
					case 200:
						this.$toast.success(response.data.msg);
						// 保存服务端返回的token、用户id
						localStorage.setItem(
							response.data.u_id + "token",
							response.data.token
						);
						localStorage.setItem("u_id", response.data.u_id);
						if (response.data.userInfo) {
							localStorage.setItem( "userInfo", JSON.stringify(response.data.userInfo) );
						}
						
						// 绑定通讯用户信息
						if ((this.websocket && this.websocket.ws && this.websocket.ws.readyState == 1) ) {
							this.websocket.ws.send(JSON.stringify({
								mk:200,
								uid:response.data.u_id,
								token:response.data.token,
								rndid:this.$store.state.common.rndid
							}));
						}
						// 登录成功跳转到首页
						if(this.prePath){
							localStorage.removeItem("before_path");
							this.$router.push({ path: this.prePath });
						}else{
							this.$router.push({ path: this.Conf.homeUrl });
						}
						break;
					  case 40001:
						this.$toast.fail(response.data.msg);
						this.changeImgCode();
						break;
				}
			})
			.catch(error => {});
		},
		onSubmit() {
			if (this.isDisable) {
				this.$toast.fail("请求正在处理，请稍候...");
			}
			if (!this.verify.flag) {
				this.$toast.fail(this.verify.msg);
				this.changeImgCode();
			} else {
				this.onSubmitBase({
					nickname: this.params.nickname,
					loginID: this.params.loginID,
					password: md5(this.params.password),
					code: this.params.code?this.params.code:'',
					captcha: this.params.captcha
				});
			}
		},
		onSubmit1() {
			if (this.isDisable) {
				this.$toast.fail("请求正在处理，请稍候...");
			}
			if (!this.verifyMsg.flag) {
				this.$toast.fail(this.verifyMsg.msg);
			} else {
				this.onSubmitBase({
					nickname: this.params.nickname,
					phone: this.params.phone,
					password: md5(this.params.password),
					code: this.params.code,
					captcha: this.params.message
				});
			}
		},
		// 点击图片修改图片src 刷新
		changeImgCode() {
			var num = Math.ceil(Math.random() * 10); //生成一个随机数（防止缓存)
			this.imgCode = this.Conf.serverUrl + "Verify/getVerify?" + num;
		},
		//获取短信验证码的时候判断是否合法
		getCode() {
			if (!this.verifyCphone.flag) {
				this.$toast.fail(this.verifyMsg.msg);
			} else {
				var url = this.Conf.serverUrl + "Verify/smsSend";
				var params = {
					mobile: this.params.phone
				};
				this.$axios.post(url, this.$qs.stringify(params)).then(response => {
				});
				this.sendCode = false;
				//    //倒计时60秒;
				this.validateBtn();
			}
		},
		//判断邀请码是否存在
		validateCode() {
			  if (!this.params.code) {
					this.$toast("邀请码不能为空");
			  } else {
				var url = this.Conf.serverUrl + "Regist/checkCode";
		  
				var params = {
					code: this.params.code
				};
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					switch (response.data.code) {
						case 200:
							this.$toast("邀请码正确");
							break;
						case 40001:
							this.$toast.fail(response.data.msg);
							break;
					}
				})
				.catch(error => {});
			}
		},
		//倒计时60秒重新获取
		validateBtn() {
			this.auth_time = 60;
			var auth_timetimer = setInterval(() => {
				this.auth_time--;
				if (this.auth_time <= 0) {
					this.sendCode = true;
					clearInterval(auth_timetimer);
				}
			}, 1000);
		},
		sacnCode() {
			this.$router.push({ path: "/Scan" });
		},
		toLogin() {
			this.$router.push({ path: "/Login" });
		},
		wxHandLogin() {
			if(!this.wxConfigs.appid) return;
		
			let states = {
				'_f':'m',
				'_id':this.$store.state.common.rndid,
				'_code':localStorage.getItem("inviter_code")||"",
				'_type':chkAndroidOrios()?2:1
			};
			if(chkWeiXin()){
				states['_f'] = 'wx';
				window.location.href = compWxAuthUrl(this.wxConfigs, states);
			}else{
				this.QRCodeUrl = compWxAuthUrl(this.wxConfigs, states);
				this.showQRCodeUrl = true;
			}

		},		
		// 复制成功
		onCopy(e) {
			this.$toast("复制成功,请在微信内打开！");
		},
		// 复制失败
		onError(e) {
			this.$toast("复制失败,稍后请重试！");
		},
		tapDownload() {
			window.open("/h5/");
		}
	},
};
</script>


<style scoped>
	.van-nav-bar{
		background-color:transparent !important;
	}
	.van-hairline--bottom::after {
		border-bottom-width:0px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/Regist.vue